import { render, staticRenderFns } from "./TifPostulacionesIndex.vue?vue&type=template&id=373dba9e"
import script from "./TifPostulacionesIndex.vue?vue&type=script&lang=js"
export * from "./TifPostulacionesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports